<template>
  <div
    class="table-wraper"
    ref="tableWraperRef"
  >
    <div ref="searchRef">
      <Search
        v-if="
          config?.search_config &&
          config.search_config.length > 0 &&
          !enable_advanced_search_multigroups
        "
        :searchConfig="config?.search_config || []"
        :fieldSearchConfig="headerFilterSearchConfig"
        :autoRefreshOnSearchChange="config?.auto_refresh_on_search_change"
        v-model:searchConditions="searchConditions"
        :event-bus="selfEventBus"
        :searchType="search_type"
        :searchDisplayType="config?.search_display_type"
        :searchColumnCount="config?.search_column_count"
        :viewSearchConfig="viewSearchConfig"
        :disabledShowSearchGroupName="config?.disabledShowSearchGroupName"
        @viewSearchConfigChange="viewSearchConfigChange"
        @change="handleSearchChange"
      ></Search>
      <SearchFormGroup
        v-if="
          config?.search_config &&
          config.search_config.length > 0 &&
          enable_advanced_search_multigroups
        "
        :searchConfig="config?.search_config || []"
        :fieldSearchConfig="headerFilterSearchConfig"
        :autoRefreshOnSearchChange="config?.auto_refresh_on_search_change"
        v-model:searchGroups="searchGroups"
        :event-bus="selfEventBus"
        :searchType="search_type"
        :searchDisplayType="config?.search_display_type"
        :searchColumnCount="config?.search_column_count"
        :disabledShowSearchGroupName="config?.disabledShowSearchGroupName"
        @change="handleSearchChange"
      ></SearchFormGroup>
    </div>
    <a-card
      ref="elRef"
      :body-style="{ padding: 0 }"
    >
      <TableHeader
        :config="config"
        :auth_batch_update_list="auth_batch_update_list"
        :auth_head_btn_list="auth_head_btn_list"
        :selectedRowKeys="selectedRowKeys"
        :dataSource="dataSource"
        :current_org="current_org"
        :router="router"
        :selfEventBus="selfEventBus"
        :loading="loading"
        :screenState="screenState"
        v-model:tableSize="state.tableSize"
        :columns="columns"
        :view_key="view_key"
        :view_flag_name="config.title"
        :is_view="is_view"
        :refreshType="refreshType"
        v-model:selectedConditionGroup="selectedConditionGroup"
        v-model:conditionGroupDataList="conditionGroupDataList"
        v-model:groupConditionValue="groupConditionValue"
        v-model:settingOpen="settingOpen"
        @refresh="refresh"
        @export="handleExport"
        @setFull="setFull"
        @exitFull="exitFull"
        @columnsChange="onColumnsChange"
        @heightChange="h => (headerHeight = h)"
        @refreshTypeChange="handleRefreshTypeChange"
        @tableSizeChange="handleTableSizeChange"
        @selectedConditionGroupChange="handleSelectedConditionGroupChange"
        @groupConditionValueChange="handleGroupConditionValueChange"
      >
        <template #header_bar_before_title>
          <slot name="header_bar_before_title"></slot>
        </template>
        <template #header_bar_after_title>
          <slot name="header_bar_after_title"></slot>
        </template>
        <template #header_bar_before_btn>
          <slot name="header_bar_before_btn"></slot>
        </template>
        <template #header_bar_after_btn>
          <slot name="header_bar_after_btn"></slot>
        </template>
      </TableHeader>
      <s-table
        v-if="columns?.length > 0"
        :columns="filtedColumns"
        v-model:selectedRowKeys="selectedRowKeys"
        :data-source="dataSource"
        :bordered="true"
        :size="state.tableSize"
        :height="tableHeight"
        :rowHeight="config.rowHeightFunc || config.rowHeight || undefined"
        :scroll="{
          x: tableContentWidth,
        }"
        :loading="loading && !config?.disabled_table_loading"
        :pagination="
          config?.is_pagination
            ? {
                current: state.current,
                pageSize: state.pageSize,
                total: state.total,
                onChange: handlePageChange,
                showSizeChanger: true,
                pageSizeOptions: pageSizeOptions,
              }
            : false
        "
        :rowKey="rowKey"
        :rowSelection="config?.is_selection ? row_selection : null"
        :custom-cell="config?.customCell"
        :custom-header-cell="config?.customHeaderCell"
        :custom-row="config?.customRow"
        :row-class-name="rowClassName"
        :virtual="true"
        sticky
        summary-fixed
        :preserveRow="preserveRow"
        :style="{
          '--row-heigth': `${config.rowHeight}px`,
        }"
        :class="{ 'modify-row-height': !!config.rowHeight }"
        @change="handleChange"
        @cellClick="handleCellClick"
        @resizeColumn="resizeColumn"
      >
        <template #customFilterDropdown="{ confirm, clearFilters, column }">
          <TableFilterDropdown
            :column="column"
            :searchConfig="headerFilterSearchConfig"
            v-model:searchConditions="headerSearchConditions"
            :searchType="search_type"
            :confirm="confirm"
            :clearFilters="clearFilters"
            @search="handleSearch"
            @reset="handleReset"
          />
        </template>
        <template
          #customFilterIcon="{ filtered, column }"
          v-if="config?.enable_custom_filter"
        >
          <FilterFilled
            :style="{
              color:
                filtered ||
                filterConditions(headerSearchConditions).some(
                  s => s.field_name === column.dataIndex,
                )
                  ? '#108ee9'
                  : undefined,
            }"
          />
        </template>
        <template #bodyCell="{ column, index, text, record }">
          <template v-if="column.dataIndex == 'index'">
            {{ index + 1 + state.pageSize * (state.current - 1) }}
          </template>
          <component
            :is="'Cell_' + column.cellComponent"
            v-else-if="column.cellComponent"
            :cmpObj="{
              column: column ? column : {},
              index: index,
              text: text,
              dataSource: dataSource,
              record: record ? record : {},
              pageSize: state.pageSize ? state.pageSize : 500,
              current: state.current ? state.current : 1,
              eventBus: eventBus,
              tableHeightY: tableHeight,
              requestParams: config.query_params,
              auth_btn_list: auth_btn_list,
              event_obj: selfEventBus,
              ...(config.cellComponentExt || {}),
            }"
          ></component>
          <template v-else>
            <span :style="column.color ? column.color({ column, index, text, record }) : null">
              {{ column.content ? column.content({ column, index, text, record }) : text }}
            </span>
          </template>
        </template>
        <template
          #summary
          v-if="summaryColumns.length > 0"
        >
          <s-table-summary-row>
            <s-table-summary-cell :index="0">合计</s-table-summary-cell>
            <s-table-summary-cell
              v-for="item in summaryColumns"
              :key="item.key"
              :columnKey="item.key"
            >
              <template #default="vars">
                <TableSummary
                  :item="item"
                  :summaryParams="vars"
                ></TableSummary>
              </template>
            </s-table-summary-cell>
          </s-table-summary-row>
        </template>
        <template #contextmenuPopup="contextmenuPopup">
          <TableContextMenu
            :contextmenuPopup="contextmenuPopup"
            :dataSource="dataSource"
            :columns="columns"
            :view_key="view_key"
            :view_flag_name="config.title"
            :is_view="is_view"
            :self-event-bus="selfEventBus"
            @refresh="refresh"
            @export="handleExport"
            @columnsChange="onColumnsChange"
          ></TableContextMenu>
        </template>
      </s-table>
    </a-card>
  </div>
  <export-excel-modal-view
    v-if="exportOpen"
    :column-list="exportExcelColumnList"
    :columns="exportExcelColumn"
    :source-columns="config.columns"
    :current="state.current"
    :datasource="dataSource"
    :filename="filename"
    :pageSize="state.pageSize"
    :total="state.total"
    :requestParams="getQueryParams({ type: 'list' })"
    :queryData="config.list_url"
    v-model:open="exportOpen"
  />
</template>

<script setup lang="ts">
import { FilterFilled } from '@ant-design/icons-vue';
import { useResizeObserver } from '@vueuse/core';
import { TableProps } from 'ant-design-vue';
import dayjs from 'dayjs';
import { getApiData } from 'liyu-pc-base/api/api-model';
import { filterConditions, genID } from 'liyu-pc-base/utils/function';
import { useFullscreen } from 'liyu-pc-base/utils/hooks/useFullscreen';
import { debounce, isArray, cloneDeep } from 'lodash';
import mitt from 'mitt';
import { computed, h, onMounted, onUnmounted, provide, reactive, ref, watch } from 'vue';
import { useRouter } from 'vue-router';
import Search from './search.vue';
import SearchFormGroup from './SearchFormGroup.vue';
import TableFilterDropdown from './TableFilterDropdown.vue';
import TableHeader from './tableHeader.vue';
import TableSummary from './TableSummary.vue';
import { useRequiredConditionStore, required_condition_event_obj } from 'liyu-pc-base/init-plugin';
import { useI18n } from 'vue-i18n';
import { useEnv, useUserStore } from 'liyu-pc-base/init-plugin';
import {
  Column,
  SearchConditionItem,
  SearchConfig,
  SearchGroupItem,
  Table,
  TableProState,
  ViewColumnItem,
  ViewData,
  Response,
  ViewSearchItem,
  ConditionGroupConfigItem,
} from './typing';
import {
  fetchViewsData,
  getParamsCount,
  tableProStateSymbol,
  getCurrentGroupConditionValue,
  getDefaultSearchOperator,
} from './utils';
import TableContextMenu from './TableContextMenu.vue';
import { useView } from './hooks/view';
import { query_view_settings_list } from 'liyu-pc-base/api/view-model';
const DEFAULT_PAGE_SIZE = 50;
const props = defineProps({
  config: {
    type: Object as () => Table,
    required: true,
    default: () => ({
      id: '',
      title: '',
      is_normal_model: true,
      modelType: null,
      list_url: '',
      columns: [],
    }),
  },
  eventBus: {
    type: Object,
    required: false,
  },
  initSelectValue: {
    type: Array,
    required: false,
  },
  initValueKey: {
    type: String,
    required: false,
  },
});
interface Emits {
  (e: 'selectChange', selectdRecord: any[], unSelectdRecord: any[]): void;
  (e: 'dataChange', params: { data: any[]; current: number; total: number }): void;
  (e: 'heightlightRowChange', record: any): void;
}
const emit = defineEmits<Emits>();
const { t } = useI18n();
const env = useEnv();
const requiredConditionStore = useRequiredConditionStore();
const userStore = useUserStore();
const userid = userStore.userid;
const current_org = userStore.currentOrg;
const VIEW_SYSTEM_EDIT = 'view_system_edit';
const is_view_system_edit_auth = ref(userStore.CHECK_AUTH(VIEW_SYSTEM_EDIT));
const router = useRouter();
const dataSource = ref([]);
const selectedRowKeys = ref([]);
const loading = ref(false);
const selfEventBus = mitt();
const searchConditions = ref<SearchConditionItem[]>([]);
const searchGroups = ref<SearchGroupItem[]>([]);
const settingOpen = ref(false);
const enable_advanced_search_multigroups = computed(
  () => !!props.config.enable_advanced_search_multigroups,
);
const heightlightRowKey = defineModel<any>('heightlightRowKey', {
  default: null,
});
/**
 * 表头搜索条件桥接 computed
 * - 未开启 enable_advanced_search_multigroups 时，直接读写 searchConditions
 * - 开启 enable_advanced_search_multigroups 时，读写 searchGroups[0].conditions
 *   使表头筛选（TableFilterDropdown / filter action）与多分组搜索第一个分组联动
 */
const headerSearchConditions = computed<SearchConditionItem[]>({
  get() {
    if (enable_advanced_search_multigroups.value) {
      return searchGroups.value[0]?.conditions || [];
    }
    return searchConditions.value;
  },
  set(val) {
    if (enable_advanced_search_multigroups.value) {
      if (searchGroups.value.length > 0) {
        searchGroups.value = searchGroups.value.map((g, i) =>
          i === 0 ? { ...g, conditions: val } : g,
        );
      } else {
        searchGroups.value = [
          {
            id: genID(),
            conditions: val,
            viewSearchConfig: {},
          },
        ];
      }
    } else {
      searchConditions.value = val;
    }
  },
});
const remoteHeaderSearchConfig = ref<SearchConfig[]>([]);
const requestedHeaderSearchConfigMap = ref<Record<string, boolean>>({});
const headerFilterSearchConfig = computed<SearchConfig[]>(() => {
  const configMap: Record<string, SearchConfig> = {};
  for (const item of remoteHeaderSearchConfig.value || []) {
    if (item?.field_name) {
      configMap[item.field_name] = item;
    }
  }
  for (const item of props.config.search_config || []) {
    if (item?.field_name) {
      configMap[item.field_name] = item;
    }
  }
  return Object.values(configMap);
});
const headerFilterSearchConfigMap = computed<Record<string, SearchConfig>>(() => {
  const configMap: Record<string, SearchConfig> = {};
  for (const item of headerFilterSearchConfig.value) {
    if (item?.field_name) {
      configMap[item.field_name] = item;
    }
  }
  return configMap;
});
let loadDataId = null;
const tableWraperRef = ref(null);
const tableWraperHeight = ref(null);
const searchRef = ref(null);
const searchHeight = ref(null);
const headerHeight = ref(0);
const rowActionWidth = ref(30);
const sortedMap = ref({});
const sortedList = ref([]);
const auth_batch_update_list = ref([]);
const auth_head_btn_list = ref<any[]>([]);
const auth_btn_list = ref<any[]>([]);
const exportOpen = ref(false);
const searchInput = ref();
const refreshType = ref(props.config.refreshType);
const selectedConditionGroup = ref<ConditionGroupConfigItem | null>(null);
const conditionGroupDataList = ref<any[]>([]);
const groupConditionValue = ref<string | null>(null);
// 记录上一次拉取分组数据时所使用的查询条件签名，用于在搜索条件等变化时重新拉取分组数据
const lastGroupQuerySignature = ref<string | null>(null);
const rowKey = computed(() => props.config?.rowKey || 'id');
/**
 * 行高亮 class 名：由 heightlightRowKey 驱动，不依赖 s-table 的 rowSelection/check 功能。
 * 背景色可在样式里通过 --table-heightlight-row-bg 覆盖。
 */
const HIGHLIGHT_ROW_CLASS = 'heightlight-row';
/**
 * s-table 的 rowClassName 回调（record, rowIndex）=> string
 * 只按 heightlightRowKey 命中行加 class，与 selectedRowKeys / rowSelection 完全解耦，
 * 因此勾选态与高亮态相互独立，不受「勾选」逻辑影响。
 */
const rowClassName = (record: any) => {
  const highlightKey = heightlightRowKey.value;
  if (highlightKey === null || highlightKey === undefined) return '';
  if (!record) return '';
  const key = record[rowKey.value];
  if (key === null || key === undefined) return '';
  return String(key) === String(highlightKey) ? HIGHLIGHT_ROW_CLASS : '';
};
const getAuthBtn = () => {
  auth_btn_list.value = userStore.CHECK_AUTH_BY_BTN_LIST(props.config?.btn_list || []) || [];
  auth_head_btn_list.value =
    userStore.CHECK_AUTH_BY_BTN_LIST(props.config?.head_btn_list || []) || [];
  auth_batch_update_list.value =
    userStore.CHECK_AUTH_BY_BTN_LIST(props.config?.batch_update_list || []) || [];
};
getAuthBtn();
const pageSizeOptions = ref(
  props.config?.pageSizeOptions || [
    '10',
    '20',
    '50',
    '100',
    '200',
    '500',
    '1000',
    '3000',
    '10000',
    '50000',
    '60000',
    '70000',
  ],
);
const view_key = computed(() => {
  return `table_pro_${props.config.key}`;
});
const state = reactive({
  current: 1,
  pageSize: props.config?.pageSize || props.config?.query_params?.pageSize || DEFAULT_PAGE_SIZE,
  total: 0,
  tableSize: 'small',
  tableHead: null,
  sum_data: null,
});
useResizeObserver(tableWraperRef, entries => {
  tableWraperHeight.value = entries[0].contentRect.height;
});
useResizeObserver(searchRef, entries => {
  searchHeight.value = entries[0].contentRect.height;
});

const preserveRow = () => {
  return false;
};
const getQueryParams = ({ type = 'list', viewData = null, groupDataList = null } = {}) => {
  const getColumnFields = (list: Column[]) => {
    const fields = [];
    list.forEach(item => {
      if (
        item.dataIndex &&
        item.dataIndex !== 'index' &&
        item.dataIndex !== 'action' &&
        item.checked !== false
      ) {
        fields.push(item.dataIndex);
      }
      if (item.children && item.children.length > 0) {
        fields.push(...getColumnFields(item.children));
      }
    });
    return fields;
  };

  const sort_fields = [];
  const used_fields = new Set();
  for (const item of sortedList.value) {
    if (item.order == 'descend') {
      sort_fields.push('-' + item.key);
    } else {
      sort_fields.push(item.key);
    }
    used_fields.add(item.key);
  }
  if (props.config.base_sort_fields) {
    for (const item of props.config.base_sort_fields) {
      const field_name = item.startsWith('-') ? item.slice(1) : item;
      if (!used_fields.has(field_name)) {
        sort_fields.push(item);
      }
    }
  }
  const params = {
    ...(props.config.query_params || {}),

    sort_fields,
  };
  if (type === 'list') {
    const column_fields = getColumnFields(columns.value || []);
    if (props.config.base_column_fields) {
      column_fields.push(...props.config.base_column_fields);
    }
    params['current'] = state.current;
    params['pageSize'] = state.pageSize;
    params['column_fields'] = column_fields;
  }
  if (search_type.value === 'advanced') {
    if (enable_advanced_search_multigroups.value) {
      const searchGroupConds = (viewData ? viewData.searchGroups || [] : searchGroups.value)
        .map(group => filterConditions(group.conditions))
        .filter(group => group.length > 0);
      const baseConds = filterConditions(props.config.base_conditions);
      const conditionsList = [];
      if (searchGroupConds.length > 0) {
        conditionsList.push({ op: 'and', children: searchGroupConds });
      }
      if (baseConds.length > 0) {
        conditionsList.push({ op: 'and', children: baseConds });
      }
      params['conditions'] = conditionsList;
    } else {
      const conditions = [
        ...filterConditions(props.config.base_conditions),
        ...filterConditions(viewData ? viewData.searchConditions || [] : searchConditions.value),
      ];
      params['conditions'] = [conditions];
    }
    if (type === 'list' || type === 'count') {
      const groupCondition = getCurrentGroupConditionValue(
        groupDataList || conditionGroupDataList.value,
        viewData ? viewData.groupConditionValue : groupConditionValue.value,
      );
      if (groupCondition) {
        params['conditions'] = [
          {
            op: 'and',
            children: params['conditions'],
          },
          {
            op: 'and',
            children: [
              {
                format: selectedConditionGroup.value?.format || 'input',
                class_name: selectedConditionGroup.value?.class_name || 'str',
                field_name: groupCondition.field_name,
                operator: 'eq',
                value: [groupCondition.value],
              },
            ],
          },
        ];
      }
    }
  } else if (search_type.value === 'simple') {
    for (const item of filterConditions(
      viewData ? viewData.searchConditions || [] : searchConditions.value,
    )) {
      const v_count = getParamsCount(item.operator, item);
      let value = item.value;
      if (v_count === 1) {
        value = value[0];
      }
      params[item.field_name] = value;
    }
  }
  if (props.config.get_query_params_func) {
    const newParams = props.config.get_query_params_func({ params, type });
    if (newParams) {
      Object.assign(params, newParams);
    }
  }
  const requiredConditionObj = getRequiredConditionObj();
  if (requiredConditionObj) {
    params['required_condition'] = requiredConditionObj;
  }
  if (props.config.get_db_alias) {
    params['db_alias'] = props.config.get_db_alias();
  }

  return params;
};
const [elRef, screenState, { setFull, exitFull }] = useFullscreen();
const getGroupDataList = async () => {
  if (!selectedConditionGroup.value) {
    if (conditionGroupDataList.value?.length > 0) {
      conditionGroupDataList.value = [];
    }
    return;
  }
  if (!props.config.query_group_url) {
    console.error('query_group_url 未配置');
    if (conditionGroupDataList.value?.length > 0) {
      conditionGroupDataList.value = [];
    }
    return;
  }
  // 分组数据的取值依赖于当前搜索/基础条件，因此需要判断影响分组结果的查询条件是否发生变化：
  // 仅当分组数据为空（首次/切换分组字段/重置），或查询条件签名发生变化（搜索条件等改变）时才重新拉取，
  // 避免翻页、排序等不影响分组结果的操作触发无意义的重复请求
  const groupParams = getQueryParams({ type: 'group' });
  const signature = JSON.stringify(groupParams);
  if (conditionGroupDataList.value?.length && signature === lastGroupQuerySignature.value) {
    return;
  }
  const params = groupParams;
  params['group_condition'] = {
    field_name: selectedConditionGroup.value.field_name,
    display_name: selectedConditionGroup.value.display_name,
    order_name: selectedConditionGroup.value.order_name || [],
  };
  const res = await getApiData(params, props.config.query_group_url || '', false, {
    api_log: `tablePro ${props.config.key} ${props.config.title}`,
  });
  conditionGroupDataList.value = res || [];
  lastGroupQuerySignature.value = signature;
  // 搜索条件变化后重新拉取分组数据时，若当前选中的分组值在最新结果中已不存在，
  // 清空选中值，避免列表仍按失效的分组值过滤导致无数据
  if (groupConditionValue.value != null) {
    const stillExists = (res || []).some(
      (item: any) => item?.group_info && item.group_info.value === groupConditionValue.value,
    );
    if (!stillExists) {
      groupConditionValue.value = null;
    }
  }
};
const getData = async () => {
  if (!props.config.list_url) {
    return;
  }
  const currentLoadId = Symbol(); // 唯一值
  loadDataId = currentLoadId;
  try {
    loading.value = true;
    await getGroupDataList();
    const params = getQueryParams({ type: 'list' });
    let response: Response;
    if (props.config.query_data_func) {
      response = await props.config.query_data_func(params);
    } else {
      response = await getApiData(
        params,
        props.config.list_url.replace('__tree', ''),
        props.config.list_url.includes('__tree'),
        {
          api_log: `tablePro ${props.config.key} ${props.config.title}`,
        },
      );
    }
    if (loadDataId !== currentLoadId) {
      return;
    }
    if (props.config.process_data_func) {
      dataSource.value = props.config.process_data_func(response.data);
    } else {
      dataSource.value = response.data || [];
    }
    state.current = response.current;
    state.total = response.total;
    state.tableHead = response.table_head ? response.table_head : null;
    state.sum_data = response.sum_data ?? null;
    emit('dataChange', {
      data: dataSource.value,
      current: response.current,
      total: response.total,
    });
    syncSelectedRowKeys();
  } finally {
    if (loadDataId !== currentLoadId) {
      return;
    }
    loading.value = false;
  }
};
const delayGetDate = debounce(getData, 500);
const handlePageChange = (page: any, pageSize: any) => {
  if (state.current == page && state.pageSize == pageSize) {
    return;
  }
  state.current = page ? page : 1;
  state.pageSize = pageSize ? pageSize : DEFAULT_PAGE_SIZE;
  getData();
};
const search_type = computed(() => {
  if (props.config.search_type === 'simple') {
    return props.config.search_type;
  } else {
    return 'advanced';
  }
});
const is_view = computed(() => {
  return props.config?.is_view !== false;
});
const row_selection: any = computed(() => {
  const rowSelectionType = props.config.rowSelectionType || 'checkbox';
  const rowSelectionCheckStrictly = props.config.rowSelectionCheckStrictly || false;
  const onChange = (selectedRowKeys, selectdRecord) => {
    const unSelectdRecord = dataSource.value.filter(item => {
      return !selectedRowKeys.includes(item.id);
    });
    emit('selectChange', selectdRecord, unSelectdRecord);
  };
  return { type: rowSelectionType, checkStrictly: rowSelectionCheckStrictly, onChange };
});
const viewColumnsConfig = ref<Record<string, ViewColumnItem>>({});
const viewSearchConfig = ref<Record<string, ViewSearchItem>>({});
const filtedColumns = computed(() => {
  const filterRecursive = (list: Column[]) => {
    return list
      .filter(item => item.checked !== false)
      .map(item => {
        if (item.children && item.children.length > 0) {
          const children = filterRecursive(item.children);
          if (children.length > 0) {
            return {
              ...item,
              children,
            };
          }
          return null;
        }
        return item;
      })
      .filter(Boolean);
  };
  return filterRecursive(columns.value);
});
const columns = computed<Column[]>(() => {
  const filterValueMap = {};
  for (const item of headerSearchConditions.value) {
    if (['in', 'eq'].includes(item.operator)) {
      filterValueMap[item.field_name] = item.value;
    }
  }
  const sorted = sortedMap.value || {};
  const baseColumns = [...(props.config.columns || [])];

  if (props.config.btn_list && props.config.btn_list.length > 0) {
    const hasAction = baseColumns.some(item => item.dataIndex === 'action');
    if (!hasAction) {
      baseColumns.push({
        title: '操作',
        dataIndex: 'action',
        cellComponent: 'action',
        width: rowActionWidth.value + 20,
        resizable: true,
        fixed: 'right',
        checked: true,
      });
    }
  }

  // 合并视图配置，递归合并
  const mergeRecursive = (list: Column[], isChildren = false): Column[] => {
    const merged = list
      .map(item => {
        const key = item.dataIndex || item.key || item.title;
        const viewCol = viewColumnsConfig.value[key] || {};
        const newItem = {
          ...item,
          ...viewCol,
          is_children: isChildren,
          key: key,
        };
        if (newItem.children && newItem.children.length > 0) {
          newItem.children = mergeRecursive(newItem.children, true);
        }
        return newItem;
      })
      .sort((a, b) => {
        const orderA = a.order ?? 999;
        const orderB = b.order ?? 999;
        return orderA - orderB;
      });

    return merged.map(item => {
      const key = item.dataIndex || item.key || item.title;
      let ellipsis = item.ellipsis;
      if (item.resizable && item.ellipsis == undefined) {
        ellipsis = true;
      }
      if (item.autoWidth) {
        return {
          ...item,
          minWidth: item.width,
          width: undefined,
          filteredValue: filterValueMap[key] || null,
          sortOrder: sorted[key] || false,
          key: key,
          ellipsis,
          customFilterDropdown:
            props.config.enable_custom_filter && !!headerFilterSearchConfigMap.value[key],
          onFilterDropdownOpenChange: open => {
            if (open) {
              setTimeout(() => {
                searchInput.value?.focus();
              }, 100);
            }
          },
        };
      } else {
        return {
          ...item,
          width: item.width,
          minWidth: undefined,
          filteredValue: filterValueMap[key] || null,
          sortOrder: sorted[key] || false,
          key: key,
          ellipsis,
          customFilterDropdown:
            props.config.enable_custom_filter && !!headerFilterSearchConfigMap.value[key],
          onFilterDropdownOpenChange: open => {
            if (open) {
              setTimeout(() => {
                searchInput.value?.focus();
              }, 100);
            }
          },
        };
      }
    });
  };

  const res: Column[] = mergeRecursive(baseColumns);
  // 序号列处理
  const hasIndex = res.some(item => item.dataIndex === 'index');
  if (!hasIndex && !props.config.hide_index_column) {
    res.unshift({
      title: '#',
      dataIndex: 'index',
      key: 'index',
      maxWidth: 50,
      fixed: 'left',
      checked: true,
      autoHeight: true,
    });
  }
  return res;
});
const tableContentWidth = computed(() => {
  let width = 0;
  const processColumns = datas => {
    for (const item of datas) {
      if (item.children && item.children.length > 0) {
        processColumns(item.children);
      } else {
        width += item.width || item.minWidth || 120;
      }
    }
  };
  processColumns(columns.value);
});
const filename = computed(() => {
  const title = props.config.title || 'data';
  const datetime = dayjs().format('YYYYMMDD_HHmmss');
  return `${title}_${datetime}`;
});
const exportExcelColumnList = computed(() => {
  const list: any = [];
  const getLeaves = (cols: Column[]) => {
    cols.forEach(item => {
      if (item.children && item.children.length > 0) {
        getLeaves(item.children);
      } else {
        if (item.dataIndex === 'action' || item.dataIndex === 'index') {
          return;
        }
        list.push({
          checked: item.checked,
          fixed: item.fixed ? item.fixed : false,
          key: item.dataIndex,
          label: item.title,
          width: item.width,
        });
      }
    });
  };
  getLeaves(columns.value);
  return list;
});
const exportExcelColumn = computed(() => {
  const list: any = [];
  const getLeaves = (cols: Column[]) => {
    cols.forEach(item => {
      if (item.children && item.children.length > 0) {
        getLeaves(item.children);
      } else {
        if (item.dataIndex === 'action' || item.dataIndex === 'index') {
          return;
        }
        list.push(item);
      }
    });
  };
  getLeaves(columns.value);
  return list;
});
const handleSearch = ({ confirm, dataIndex, value }) => {
  confirm();
  getData();
  isViewChange.value = true;
};

const handleReset = ({ clearFilters, dataIndex }) => {
  clearFilters();
  const conditions = cloneDeep(headerSearchConditions.value);
  const conditionIndex = conditions.findIndex(item => item.field_name === dataIndex);
  if (conditionIndex > -1) {
    conditions.splice(conditionIndex, 1);
  }
  headerSearchConditions.value = conditions;
  getData();
  isViewChange.value = true;
};

const refresh = async () => {
  await getData();
};
const local_refresh = async () => {
  dataSource.value = [...dataSource.value];
};
const handleRefreshTypeChange = type => {
  refreshType.value = type;
  isViewChange.value = true;
};
const paginationHeight = ref(64);
const tableHeight = computed(() => {
  if (!tableWraperHeight.value) {
    return 0;
  }
  let value = tableWraperHeight.value - searchHeight.value - headerHeight.value - 4;
  if (props.config.is_pagination) {
    value -= paginationHeight.value;
  }
  console.log('tableWraperHeight', tableWraperHeight.value);
  console.log('searchHeight', searchHeight.value);
  console.log('headerHeight', headerHeight.value);
  console.log('paginationHeight', paginationHeight.value);
  console.log('tableHeight', value);
  return value;
});
const handleTableSizeChange = () => {
  isViewChange.value = true;
};
watch(
  () => state.tableSize,
  () => {
    // 此处设置paginationHeight两次，为了解决切换表格密度后，高度剧烈变化问题。
    paginationHeight.value = 64;
    setTimeout(() => {
      if (state.tableSize === 'small') {
        paginationHeight.value = 56;
      } else if (state.tableSize === 'middle') {
        paginationHeight.value = 56;
      } else if (state.tableSize === 'default') {
        paginationHeight.value = 64;
      }
    }, 200);
  },
);
const syncSelectedRowKeys = () => {
  if (dataSource.value?.length > 0 && props.initValueKey) {
    const valueMap = {};
    selectedRowKeys.value = dataSource.value
      .filter(item => {
        const value = item[props.initValueKey];
        if (props.initSelectValue?.includes(value) && !valueMap[value]) {
          valueMap[value] = true;
          return true;
        }
      })
      .map(item => {
        return item.id;
      });
  }
};
const init = async () => {
  conditionGroupDataList.value = [];
  const defaultSortField = props.config.columns.filter(
    column => column.sorter && column.defaultSortOrder,
  );
  defaultSortField.sort((a, b) => (a.defaultSortIndex || 0) - (b.defaultSortIndex || 0));
  for (const column of defaultSortField) {
    sortedMap.value[column.dataIndex] = column.defaultSortOrder;
    sortedList.value.push({ key: column.dataIndex, order: column.defaultSortOrder });
  }
  const tmpSearchConditions = [];
  if (props.config?.search_config) {
    props.config.search_config.forEach(configItem => {
      if (configItem.default_value) {
        let value = configItem.default_value;
        if (!isArray(value)) {
          value = [value];
        }
        tmpSearchConditions.push({
          field_name: configItem.field_name,
          value: value,
          operator: getDefaultSearchOperator(configItem),
          format: configItem.format || 'input',
          class_name: configItem.class_name || 'str',
        });
      }
    });
  }

  searchConditions.value = tmpSearchConditions;
  if (enable_advanced_search_multigroups.value) {
    if (props.config.default_advanced_search_multigroups) {
      searchGroups.value = props.config.default_advanced_search_multigroups;
    } else {
      searchGroups.value = [
        {
          id: genID(),
          conditions: [...tmpSearchConditions],
          viewSearchConfig: {},
        },
      ];
    }

    searchConditions.value = [];
  }
  if (is_view) {
    if (currentView.value?.id !== 'no-view') {
      currentView.value = null;
      await fetchViews();
      if (props.config?.view_uid) {
        const findView = viewDataList.value.find((item: any) => item.uid == props.config?.view_uid);
        if (findView) {
          setViewData(findView.data);
          currentView.value = findView;
        } else {
          const res: any = await query_view_settings_list({
            org_id: current_org.id,
            is_active: true,
            uid: props.config?.view_uid,
          });
          if (res?.length) {
            currentView.value = { ...res[0], is_other_user_view: true };
          }
        }
      }
      if (!currentView.value && viewDataList.value?.length) {
        const tmpData = [...viewDataList.value];
        // 优先级：当前选中视图，默认视图，用户视图，同级按 sort 正序
        const getSortValue = item => {
          let value = item.sort || 0;
          if (item.id !== currentView.value?.id) {
            value *= 1000000;
          }
          if (!item.is_default) {
            value *= 10000;
          }
          if (!item.user_id) {
            value *= 1000;
          }
          return value;
        };
        tmpData.sort((a, b) => getSortValue(a) - getSortValue(b));
        setViewData(tmpData[0].data);
        currentView.value = tmpData[0];
      }
    }
  }
  await getData();
};
const eventReinit = async () => {
  isViewChange.value = false;
  await init();
};
const eventReload = async () => {
  await getData();
};
const flattenedColumns = computed(() => {
  const list = [];
  const getLeaves = (cols: Column[]) => {
    cols.forEach(col => {
      if (col.children && col.children.length > 0) {
        getLeaves(col.children);
      } else {
        list.push(col);
      }
    });
  };
  getLeaves(filtedColumns.value);
  return list;
});
const loadRemoteHeaderSearchConfig = async () => {
  if (!props.config.enable_custom_filter || !props.config.query_field_search_config_url) {
    return;
  }
  if (!current_org?.id) {
    return;
  }
  const field_name_list = flattenedColumns.value
    .map(item => item.dataIndex)
    .filter(
      item =>
        !!item &&
        item !== 'index' &&
        item !== 'action' &&
        !headerFilterSearchConfigMap.value[item] &&
        !requestedHeaderSearchConfigMap.value[item],
    );
  if (!field_name_list.length) {
    return;
  }
  field_name_list.forEach(item => {
    requestedHeaderSearchConfigMap.value[item] = true;
  });
  try {
    const res = await getApiData(
      {
        org_id: current_org.id,
        field_name_list,
      },
      props.config.query_field_search_config_url,
      false,
      {
        api_log: `tablePro ${props.config.key} ${props.config.title} query_field_search_config`,
        skip_error: true,
      },
    );
    if (!Array.isArray(res) || res.length === 0) {
      return;
    }
    const configMap: Record<string, SearchConfig> = {};
    for (const item of remoteHeaderSearchConfig.value) {
      if (item?.field_name) {
        configMap[item.field_name] = item;
      }
    }
    for (const item of res) {
      if (item?.field_name) {
        configMap[item.field_name] = item;
      }
    }
    remoteHeaderSearchConfig.value = Object.values(configMap);
  } catch (error) {
    field_name_list.forEach(item => {
      delete requestedHeaderSearchConfigMap.value[item];
    });
  }
};
const summaryColumns = computed(() => {
  const list: any = [];
  let index = 0;
  for (const item of flattenedColumns.value) {
    let _index = index;
    if (props.config?.is_selection) {
      _index = index + 1;
    }
    if (item.summary) {
      // if (!props.config.is_selection && props.config.hide_index_column) {
      //   console.error('未开启选择(is_selection)且隐藏了序号列(hide_index_column)，无法展示"合计"');
      //   return [];
      // }
      list.push({
        index: _index,
        key: item.key,
        columnKey: item.dataIndex,
        total_color: item.total_color,
        total_content: item.total_content,
        cellSummaryComponent: item.cellSummaryComponent,
        column: item,
        sum_data: state.sum_data,
      });
    }
    index++;
  }
  return list;
});
const getRequiredConditionObj = () => {
  const required_condition = props.config.required_condition;
  if (required_condition) {
    const required_condition_obj = {};
    required_condition.forEach((item: any) => {
      const value = requiredConditionStore.value_map[item.key];
      if (value !== undefined && value !== null) {
        required_condition_obj[item.field_name] = value;
      }
    });
    return required_condition_obj;
  } else {
    return null;
  }
};
const handleChange: TableProps['onChange'] = (pagination, filters, sorter, action) => {
  if (action.action === 'paginate') {
    return;
  } else if (action.action === 'filter') {
    const searchMap = {};
    for (const item of headerSearchConditions.value) {
      searchMap[item.field_name] = item;
    }
    for (const key of Object.keys(filters)) {
      const value = filters[key];
      const item = searchMap[key];
      if (item) {
        if (value?.length > 1) {
          item.operator = 'in';
        } else {
          if (!['in', 'eq'].includes(item.operator)) {
            item.operator = 'in';
          }
        }
        item.value = value;
      } else {
        searchMap[key] = {
          field_name: key,
          operator: 'eq',
          value: value,
          format: 'input',
          class_name: 'str',
        };
      }
    }
    headerSearchConditions.value = Object.values(searchMap);
    getData();
    isViewChange.value = true;
  } else if (action.action === 'sort') {
    const tmpMap = {};
    const tmpList = [];
    if (!isArray(sorter)) {
      tmpMap[sorter.columnKey] = sorter.order;
      tmpList.push({ key: sorter.columnKey, order: sorter.order });
    } else {
      for (const item of sorter) {
        tmpMap[item.columnKey] = item.order;
        tmpList.push({ key: item.columnKey, order: item.order });
      }
    }
    sortedMap.value = tmpMap;
    sortedList.value = tmpList;
    getData();
    isViewChange.value = true;
  }
};
const handleCellClick = (e, cell) => {
  if (props.config?.is_click_selection) {
    const rowSelectionType = props.config.rowSelectionType || 'checkbox';
    if (rowSelectionType === 'radio') {
      selectedRowKeys.value = [cell.record[rowKey.value]];
    } else {
      const isSelected =
        selectedRowKeys.value && selectedRowKeys.value.includes(cell.record[rowKey.value]);
      if (isSelected) {
        selectedRowKeys.value = selectedRowKeys.value.filter(item => {
          return item !== cell.record[rowKey.value];
        });
      } else {
        selectedRowKeys.value.push(cell.record[rowKey.value]);
      }
    }

    const selectdRecord = dataSource.value.filter(item => {
      return selectedRowKeys.value.includes(item[rowKey.value]);
    });
    const unSelectdRecord = dataSource.value.filter(item => {
      return !selectedRowKeys.value.includes(item[rowKey.value]);
    });
    emit('selectChange', selectdRecord, unSelectdRecord);
  }
  if (props.config?.is_click_heightlight) {
    if (heightlightRowKey.value !== cell.record[rowKey.value]) {
      heightlightRowKey.value = cell.record[rowKey.value];
      emit('heightlightRowChange', cell.record);
    }
  }
};
const handleRequiredConditionChange = (key: string) => {
  if (props.config.required_condition) {
    const item = props.config.required_condition.find((item: any) => item.key === key);
    if (item) {
      conditionGroupDataList.value = [];
      getData();
    }
  }
};
onMounted(async () => {
  if (!props.config.key) {
    console.error('tablePro config 未配置 key');
  }
  if (!props.config.title) {
    console.error('tablePro config 未配置 title');
  }
  required_condition_event_obj().on('change', handleRequiredConditionChange);
  selfEventBus.on('refresh', refresh);
  selfEventBus.on('local_refresh', local_refresh);
  selfEventBus.on('reinit', eventReinit);
  selfEventBus.on('saveView', saveView);
  selfEventBus.on('saveNewView', addView);
  if (props.eventBus) {
    props.eventBus.on('reinit', eventReinit);
    props.eventBus.on('refresh', refresh);
    props.eventBus.on('local_refresh', local_refresh);
    props.eventBus.on('reload_table', eventReload);
  }
  if (props.config.tableSize) {
    state.tableSize = props.config.tableSize;
  }
  await init();
});
const handleExport = () => {
  exportOpen.value = true;
};
const onColumnsChange = (data: any[]) => {
  if (!props.config || !props.config.columns) return;
  const configObj: Record<string, any> = {};

  const processRecursive = (list: any[]) => {
    list.forEach((item, index) => {
      const dataIndex = item.dataIndex || item.key || item.title;
      if (dataIndex === 'index' || dataIndex === 'action') return;
      configObj[dataIndex] = {
        checked: item.checked,
        fixed: item.fixed,
        autoHeight: item.autoHeight,
        autoWidth: item.autoWidth,
        ellipsis: item.ellipsis,
        width: item.width,
        order: index,
      };
      if (item.children && item.children.length > 0) {
        processRecursive(item.children);
      }
    });
  };

  processRecursive(data);
  viewColumnsConfig.value = configObj;
  isViewChange.value = true;
};
const setViewData = async (viewData: ViewData) => {
  if (viewData === null) {
    await init();
    isViewChange.value = false;
    return;
  }
  if (viewData.columns) {
    viewColumnsConfig.value = viewData.columns;
  }
  if (enable_advanced_search_multigroups.value) {
    if (viewData.searchGroups && viewData.searchGroups.length > 0) {
      searchGroups.value = viewData.searchGroups;
    } else if (viewData.searchConditions) {
      searchGroups.value = [
        {
          id: genID(),
          conditions: viewData.searchConditions,
          viewSearchConfig: viewData.searchConfig || {},
        },
      ];
    }
    // 保证至少存在一个分组
    if (searchGroups.value.length === 0) {
      searchGroups.value = [
        {
          id: genID(),
          conditions: [],
          viewSearchConfig: {},
        },
      ];
    }
    searchConditions.value = [];
  } else {
    if (viewData.searchConfig) {
      viewSearchConfig.value = viewData.searchConfig;
    }
    if (viewData.searchConditions) {
      searchConditions.value = viewData.searchConditions;
    }
  }
  if (viewData.tableSize) {
    state.tableSize = viewData.tableSize;
  }
  if (viewData.refreshType) {
    refreshType.value = viewData.refreshType;
  }
  if (viewData.sortedList) {
    sortedList.value = viewData.sortedList;
    sortedMap.value = {};
    for (const item of sortedList.value) {
      sortedMap.value[item.key] = item.order;
    }
  }
  if (viewData.groupConditionFieldName && props.config.condition_group_config_list?.length > 0) {
    selectedConditionGroup.value = props.config.condition_group_config_list.find(
      item => item.field_name === viewData.groupConditionFieldName,
    );
  } else {
    selectedConditionGroup.value = null;
  }

  groupConditionValue.value = viewData.groupConditionValue;

  if (props.config.set_view_callback) {
    props.config.set_view_callback({ viewData });
  }
  await refresh();
  isViewChange.value = false;
};
const resizeColumn = (width, column, action: 'start' | 'move' | 'end') => {
  if (action === 'end') {
    let item = viewColumnsConfig.value[column.dataIndex];
    if (!item) {
      item = {};
      viewColumnsConfig.value[column.dataIndex] = item;
    }
    item.width = width;
    isViewChange.value = true;
  }
};
const viewSearchConfigChange = (config: Record<string, ViewSearchItem>) => {
  viewSearchConfig.value = config;
  isViewChange.value = true;
};
const getViewData = (): ViewData => {
  const viewData: any = {
    columns: viewColumnsConfig.value,
    searchConditions: searchConditions.value,
    tableSize: state.tableSize,
    refreshType: refreshType.value,
    searchConfig: viewSearchConfig.value,
    sortedList: sortedList.value,
    groupConditionFieldName: selectedConditionGroup.value?.field_name,
    groupConditionValue: groupConditionValue.value,
  };
  if (enable_advanced_search_multigroups.value) {
    viewData.searchGroups = searchGroups.value;
    // 将第一个分组的字段配置作为全局 searchConfig 保存，便于单分组模式兼容
    if (searchGroups.value.length > 0) {
      viewData.searchConfig = searchGroups.value[0].viewSearchConfig;
    }
  }
  if (props.config.get_view_data_func) {
    const newViewData = props.config.get_view_data_func({ viewData });
    if (newViewData) {
      Object.assign(viewData, newViewData);
    }
  }
  return viewData;
};
const viewDataList = ref([]);
const currentView = ref<any>(null);
const isViewChange = ref(false);
const fetchViews = async () => {
  const data = await fetchViewsData(
    view_key.value,
    getQueryParams,
    props.config.count_url,
    props.config,
  );
  viewDataList.value = data;
};
const handleSearchChange = () => {
  isViewChange.value = true;
};
const handleGroupConditionValueChange = (value: any) => {
  isViewChange.value = true;
};
const handleSelectedConditionGroupChange = (item: ConditionGroupConfigItem) => {
  conditionGroupDataList.value = [];
  isViewChange.value = true;
};
const { saveView, addView } = useView({
  currentView,
  getViewData,
  isViewChange,
  userid,
  view_project__flag: env.VITE_APP_VIEW_PROJECT_FLAG,
  view_menu__flag: view_key.value,
  view_menu__name: props.config.title,
  fetchViews,
  is_auth: is_view_system_edit_auth,
  t,
});

provide<TableProState>(tableProStateSymbol, {
  setViewData,
  getViewData,
  fetchViews,
  viewDataList,
  currentView,
  isViewChange,
  config: props.config,
});

onUnmounted(() => {
  selfEventBus.off('refresh', refresh);
  selfEventBus.off('local_refresh', local_refresh);
  selfEventBus.off('reinit', eventReinit);
  selfEventBus.off('saveView', saveView);
  selfEventBus.off('saveNewView', addView);
  if (props.eventBus) {
    props.eventBus.off('reinit', eventReinit);
    props.eventBus.off('refresh', refresh);
    props.eventBus.off('local_refresh', local_refresh);
    props.eventBus.off('reload_table', eventReload);
  }
});
watch(
  () => props.initSelectValue,
  () => {
    syncSelectedRowKeys();
  },
);
watch(
  () => props.config.query_params,
  () => {
    delayGetDate();
  },
  {
    deep: true,
  },
);
watch(
  () => props.config.base_conditions,
  () => {
    delayGetDate();
  },
  {
    deep: true,
  },
);
watch(
  () => [props.config.key, props.config.query_field_search_config_url],
  () => {
    remoteHeaderSearchConfig.value = [];
    requestedHeaderSearchConfigMap.value = {};
  },
  {
    immediate: true,
  },
);
watch(
  [
    flattenedColumns,
    () => props.config.query_field_search_config_url,
    () => props.config.enable_custom_filter,
    () => props.config.search_config,
    () => current_org?.id,
  ],
  () => {
    loadRemoteHeaderSearchConfig();
  },
  {
    immediate: true,
    deep: true,
  },
);

defineExpose({
  getViewData,
  setViewData,
  config: props.config,
  columns,
  fetchViews,
  viewDataList,
  currentView,
  isViewChange,
  viewColumnsConfig,
  searchGroups,
  refresh,
  init,
  dataSource,
  selectedRowKeys,
  settingOpen,
  getQueryParams,
});
</script>
<style lang="less" scoped>
.btn-wraper {
  display: flex;
  justify-content: flex-end;
}
.table-wraper {
  height: 100%;
  overflow: hidden;
  // 行高亮背景色，可通过覆盖该变量自定义
  --table-heightlight-row-bg: #fff1b8;
  // 行高亮：由 heightlightRowKey 命中，纯视觉高亮，与 s-table 勾选态（surely-table-row-selected）互不干扰。
  // 编译后选择器为 `.table-wraper[data-v-x] .surely-table-row.heightlight-row`（特异度 0,4,0），
  // 高于行 hover/勾选态（.surely-table-row.surely-table-row-hover / -selected，均为 0,2,0），无需 !important。
  :deep(.surely-table-row.heightlight-row) {
    background-color: var(--table-heightlight-row-bg);
    .surely-table-cell:not(.surely-table-body-cell-range-selected) {
      background-color: inherit;
    }
  }
}
.modify-row-height {
  :deep(.surely-table-header) {
    height: var(--row-heigth) !important;
  }
  :deep(.surely-table-header-cell) {
    height: var(--row-heigth) !important;
  }
  :deep(.surely-table-summary) {
    height: var(--row-heigth) !important;
  }
}
.popup-divider {
  :deep(.ant-divider-horizontal) {
    margin-top: 1px;
    margin-bottom: 1px;
  }
}
.highlight {
  background-color: rgb(255, 192, 105);
  padding: 0px;
}
</style>
